import React, { useState, useEffect, useRef } from 'react';
import './EnrolNow.css';
import './BookTrail.css';
import { areas } from '../Centers/areas';
import axios from "axios";
import Swal from 'sweetalert2';
import HolidayNotice from './holidayNotice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from "react-router-dom";
const Reschedule = () => {
  const [userName, setUserName] = useState('');
  const [isCreatingNewChild, setIsCreatingNewChild] = useState(false);
  const [selectedChildId, setSelectedChildId] = useState(null);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [holidayName, setHolidayName] = useState(null);
  const [showCreateChildInput, setShowCreateChildInput] = useState(false);
  const [newChildName, setNewChildName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [showAreaDropdown, setShowAreaDropdown] = useState(false);
  const [selectedCenter, setSelectedCenter] = useState('');
  const [trialTimes, setTrialTimes] = useState([]);
  const [showCenterDropdown, setShowCenterDropdown] = useState(false);
  const [showChildDropdown, setShowChildDropdown] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const dropdownRef = useRef(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const selectWrapperRef = useRef(null);
  const childDropdownRef = useRef(null);
  const [centers, setCenters] = useState([]);
  const navigate = useNavigate();
  const [selectedTrialDate, setSelectedTrialDate] = useState('');
  const [selectedTrialTime, setSelectedTrialTime] = useState('');
  const [trialDates, setTrialDates] = useState([]);
  const [parentUserId, setParentUserId] = useState(null);

  const [errorMessages, setErrorMessages] = useState({
    userName: '',
    contactNumber: '',
    selectedArea: '',
    selectedCenter: '',
    selectedTrialTime: '',
    otp: '',
    child: '',
    userCategory: '',
    proficiencyLevel: '',
  });
  const areaDropdownRef = useRef(null);
  const centerDropdownRef = useRef(null);
  const [userDetails, setUserDetails] = useState(null);
  const [parentId, setParentId] = useState(null);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [userCategory, setUserCategory] = useState(''); // Default to Adult
  const [proficiencyLevel, setProficiencyLevel] = useState('');
  const [filteredChildren, setFilteredChildren] = useState([]);
  const handleCategoryChange = (category) => {
    setUserCategory(category);
    setErrorMessages((prevErrors) => ({ ...prevErrors, userCategory: '' })); // Clear error
  };

  const handleProficiencyChange = (level) => {
    setProficiencyLevel(level);
    setErrorMessages((prevErrors) => ({ ...prevErrors, proficiencyLevel: '' })); // Clear error
  };
  useEffect(() => {
    // Reset selected date and time slot when category changes
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]); // Clear available slots
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
      selectedTrialTime: '',
    }));
  }, [userCategory]);
  
  useEffect(() => {
    // Reset selected date and time slot when proficiency level changes
    setSelectedTrialDate('');
    setSelectedTrialTime('');
    setAvailableSlots([]); // Clear available slots
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
      selectedTrialTime: '',
    }));
  }, [proficiencyLevel]);

  useEffect(() => {
    if (contactNumber) {
      setIsOtpVerified(false);
      setOtp('');
      setUserName('');
      setUserDetails(null);
      setShowOtpInput(false);
      setIsNewUser(false);
      setSelectedArea('');
      setSelectedChildId(null);
      setSelectedCenter('');
      setSelectedTrialDate('');
      setSelectedTrialTime('');
      setFilteredChildren([]); // Clear filtered children
      setErrorMessages({
        userName: '',
        contactNumber: '',
        selectedArea: '',
        selectedCenter: '',
        selectedTrialTime: '',
        otp: '',
        child: '',
        userCategory: '',
        proficiencyLevel: '',
      });
    }
  }, [contactNumber]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (areaDropdownRef.current && !areaDropdownRef.current.contains(event.target)) {
        setShowAreaDropdown(false);
      }
      if (centerDropdownRef.current && !centerDropdownRef.current.contains(event.target)) {
        setShowCenterDropdown(false);
      }
      if (childDropdownRef.current && !childDropdownRef.current.contains(event.target)) {
        setShowChildDropdown(false);
        setShowCreateChildInput(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const fetchSportsCenters = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_API_URL_CENTER, {
            method: 'GET', // Adjust method if needed
            headers: {
                'Content-Type': 'application/json',
                'x-api-key':process.env.REACT_APP_API_KEY,
            }
        });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch sports centers.');
      }

      const centersData = Object.values(data.sportsToAcademiesMap.Badminton).flat();
      setCenters(centersData.map(center => ({
        id: center.id,
        name: center.name,
        latitude: center.latitude,
        longitude: center.longitude,
      })));
    } catch (error) {
      console.error('Error fetching data:', error);
      showBackendError(error);
    }
  };

  useEffect(() => {
    fetchSportsCenters();
  }, []);


  useEffect(() => {

  }, [selectedChildId]);


  const handleAreaChange = (areaName) => {
    setSelectedArea(areaName);
    setSelectedCenter('');
    setSelectedTrialDate('')
    setSelectedTrialTime('');
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedArea: '',
      selectedCenter: '',
      selectedTrialDate: '',
      selectedTrialTime: ''
    }));
    setShowAreaDropdown(false);
  };

  const handleCenterChange = (centerName) => {
    const selectedCenterData = centers.find(center => center.name === centerName);
    setSelectedCenter(centerName);
    setSelectedTrialTime('');
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedCenter: '',
      selectedTrialTime: ''
    }));
    setShowCenterDropdown(false);

  };

  const fetchUserDetails = async (mobileNumber) => {
    try {
      const formattedMobileNumber = mobileNumber.startsWith('+91')
        ? mobileNumber
        : '+91' + mobileNumber;
  
        const response = await fetch(process.env.REACT_APP_API_URL_FETCH_DETAILS2, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({ mobileNumber: formattedMobileNumber, source: 'COACHING',sport_id:1}),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch user details.');
      }
  
      if (data && data.userDetails && data.userDetails.success) {

  
        const parent = data.userDetails.parent;
        const children = data.userDetails.children || [];
  
        // Check if trial_details is an object and meets the criteria
        const isParentEligible = parent.trial_details &&
          parent.trial_details.sport_id === 1 &&
          parent.trial_details.trial_type === 'COACHING';

  
        const filteredChildren = children.filter(
          (child) =>
            child.trial_details &&
            child.trial_details.sport_id === 1 &&
            child.trial_details.trial_type === 'COACHING'
        );

        // Check if parent or children meet the criteria
        if (isParentEligible || filteredChildren.length > 0) {
          setUserDetails(data.userDetails);
          setIsNewUser(false);
  
          if (isParentEligible) {

            setParentId(parent.id || null);
            setUserName(parent.name || 'Unknown');
            setSelectedChildId('parent'); // Use 'parent' as a unique identifier
          
            // Ensure trial details are available
            if (parent.trial_details) {
              const trialDetail = parent.trial_details;
  
            
              setSelectedArea(trialDetail.area);
              const centerName = getCenterNameById(trialDetail.academy_id);

            
              setSelectedCenter(centerName);
              setPreviousCenter(trialDetail.academy_id);
            }
            
          }
           else {
            setParentId(null);
          }
  
          if (filteredChildren.length > 0) {
            setFilteredChildren(filteredChildren); // Update state for children
            const firstFilteredChild = filteredChildren[0];
            const firstChildId = firstFilteredChild.id;
            setSelectedChildId(null);

          }
        }else {
          // Neither parent nor children meet the criteria
          setUserDetails(null);
          setIsNewUser(true);
          setParentId(null);
          setSelectedChildId(null);
          // Neither parent nor children meet the criteria
          Swal.fire({
            icon: 'info',
            title: 'No Details Found',
            text: 'No matching parent or child found. Please return home and book a trial.',
            confirmButtonText: 'OK'
          }).then(() => {
            navigate('/'); // Redirect to home page
          });
        }
      } else {
            // User details not found or success is false
            setUserDetails(null);
            setIsNewUser(true);
            setParentId(null);
            setSelectedChildId(null);
        // Neither parent nor children meet the criteria
        Swal.fire({
          icon: 'info',
          title: 'No Details Found',
          text: 'No matching parent or child found. Please return home and book a trial.',
          confirmButtonText: 'OK'
        }).then(() => {
          navigate('/'); // Redirect to home page
        });
      }
    } catch (error) {
      setIsNewUser(true);
      setParentId(null);
      setSelectedChildId(null);
      console.error('Error fetching user details:', error);
      // Neither parent nor children meet the criteria
      Swal.fire({
        icon: 'info',
        title: 'No Details Found',
        text: 'No matching parent or child found. Please return home and book a trial.',
        confirmButtonText: 'OK'
      }).then(() => {
        navigate('/'); // Redirect to home page
      });
    }
  };

  const handleOptionSelect = (id) => {
    setSelectedCenter(id);
    setShowCenterDropdown(false);
  };
  const [previousCenter, setPreviousCenter] = useState(null);

  const handleChildSelect = (child) => {
    if (child.isParent) {

      setSelectedChildId('parent'); // Unique value for parent
      setUserName(child.name);
      setParentUserId(userDetails.parent.id);
      setIsCreatingNewChild(false);
  
      // Ensure trial details are available
      if (userDetails.parent.trial_details) {
        const trialDetail = userDetails.parent.trial_details;
  
        setSelectedArea(trialDetail.area);
        const centerName = getCenterNameById(trialDetail.academy_id);
        setSelectedCenter(centerName);
        setPreviousCenter(trialDetail.academy_id); // Store previous center ID
  
        // Set category and proficiency level from trial details
        setUserCategory(trialDetail.batch_type === 'ADULTS' ? 'Adult' : 'Kids');
        setProficiencyLevel(
          trialDetail.proficiency === 'BASIC'
            ? 'Basic'
            : trialDetail.proficiency === 'INTERMEDIATE'
            ? 'Intermediate'
            : 'Advanced'
        );
      }
    } else {

      setSelectedChildId(child.id); // Unique value for child
      setUserName(child.name);
      setParentUserId(null);
      setIsCreatingNewChild(false);
  
      // Pre-select area, center, category, and proficiency based on the child's trial details
      if (child.trial_details) {
        const trialDetail = child.trial_details;
  
        setSelectedArea(trialDetail.area);
        const centerName = getCenterNameById(trialDetail.academy_id);
        setSelectedCenter(centerName);
        setPreviousCenter(trialDetail.academy_id); // Store previous center ID
  
        // Set category and proficiency level from trial details
        setUserCategory(trialDetail.batch_type === 'ADULTS' ? 'Adult' : 'Kids');
        setProficiencyLevel(
          trialDetail.proficiency === 'BASIC'
            ? 'Basic'
            : trialDetail.proficiency === 'INTERMEDIATE'
            ? 'Intermediate'
            : 'Advanced'
        );
      }
    }
  
    setErrorMessages((prevErrors) => ({ ...prevErrors, child: '' })); // Clear error
    setShowChildDropdown(false);
  };
  
  const getCenterNameById = (academyId) => {
    if (!centers || centers.length === 0) {

      return "";
    }
    const center = centers.find(center => center.id === academyId);
    return center ? center.name : "Unknown Center";
  };
  
  useEffect(() => {
    if (selectedChildId === 'parent' && userDetails?.parent) {
      const parent = userDetails.parent;
  
      if (parent.trial_details) {
        const trialDetail = parent.trial_details;
  
        setSelectedArea(trialDetail.area);
        const centerName = getCenterNameById(trialDetail.academy_id);
        setSelectedCenter(centerName); // ✅ Update center when switching back to parent
        setPreviousCenter(trialDetail.academy_id);
  
        setUserCategory(trialDetail.batch_type === 'ADULTS' ? 'Adult' : 'Kids');
        setProficiencyLevel(
          trialDetail.proficiency === 'BASIC'
            ? 'Basic'
            : trialDetail.proficiency === 'INTERMEDIATE'
            ? 'Intermediate'
            : 'Advanced'
        );
      }
    } else if (selectedChildId && centers.length > 0) {
      const selectedChild = filteredChildren.find(child => child.id === selectedChildId);
  
      if (selectedChild && selectedChild.trial_details) {
        const trialDetail = selectedChild.trial_details;
  
        setSelectedArea(trialDetail.area);
        const centerName = getCenterNameById(trialDetail.academy_id);
        setSelectedCenter(centerName);
        setPreviousCenter(trialDetail.academy_id);
  
        setUserCategory(trialDetail.batch_type === 'ADULTS' ? 'Adult' : 'Kids');
        setProficiencyLevel(
          trialDetail.proficiency === 'BASIC'
            ? 'Basic'
            : trialDetail.proficiency === 'INTERMEDIATE'
            ? 'Intermediate'
            : 'Advanced'
        );
      }
    }
  }, [selectedChildId, centers, userDetails, filteredChildren]);

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    let errors = {
      userName: !userName.trim() ? 'Name is required' : '',
      contactNumber: !contactNumber.trim() || !isContactNumberValid ? 'Please enter a valid contact number' : '',
      selectedArea: !selectedArea ? 'Please select an area' : '',
      selectedCenter: !selectedCenter ? 'Please select a center' : '',
      selectedTrialDate: !selectedTrialDate ? 'Please select a date' : '',
      selectedTrialTime: !selectedTrialTime ? 'Please select a trial time' : '',
      otp: !isOtpVerified ? 'Please verify OTP before submitting' : '',
      child: !userName.trim() ? 'Please select or create a child' : '',
      userCategory: !userCategory.trim() ? 'Please select a Category' : '', // Validate userCategory
      proficiencyLevel: !proficiencyLevel.trim() ? 'Please select a Proficiency Level' : '', // Validate proficiencyLevel
    };

    const hasErrors = Object.values(errors).some((error) => error !== '');

    if (hasErrors) {
      setErrorMessages(errors);
      return;
    }

    try {
      const bookingData = {
        userName,
        contactNumber,
        selectedArea,
        selectedCenter,
        selectedTrialDate: formatDate(selectedTrialDate), // Format the date
        selectedTrialTime,
        selectedChildId,
      };

      setFormData(bookingData);
      setShowConfirmationModal(true);
    } catch (error) {
      console.error('Error during form submission:', error);
      setErrorMessages({ api: 'Failed to process the booking' });
      showBackendError(error);
    }
  };

  const handleOtpVerification = async () => {
    try {
      const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;
      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_VERIFY, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
          otp: otp,
        },
      });

      if (response.data.success) {
        setIsOtpVerified(true);
  
      } else {
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          otp: response.data.message || 'Invalid OTP, please try again',
        }));
        Swal.fire({
          icon: 'error',
          title: 'Invalid OTP',
          text: response.data.message || 'The OTP you entered is invalid. Please try again.',
        });
      }
    } catch (error) {
      setErrorMessages((prevErrors) => ({
        ...prevErrors,
        otp: 'Failed to verify OTP. Please try again.',
      }));
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to verify OTP. Please try again.',
      });
    }
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setErrorMessages((prevErrors) => ({ ...prevErrors, [field]: '' }));

    if (field === 'userName') {
      setUserName(value);
    } else if (field === 'contactNumber') {
      setContactNumber(value);
    } else if (field === 'otp') {
      setOtp(value);
    } 
  };
  const handleSendOtpClick = async () => {
    try {
      // Ensure the contact number starts with +91
      const formattedContactNumber = contactNumber.startsWith('+91') ? contactNumber : `+91${contactNumber}`;

      // Send the mobile number to the API with the required body format
      const response = await axios.post(process.env.REACT_APP_API_URL_OTP_SEND, {
        data: {
          phone_number: formattedContactNumber,
          has_firebase_check: false,
        },
      });

      if (response.data.success) {
        setShowOtpInput(true);
        setIsOtpVerified(false);
        setOtp('');
  
        await fetchUserDetails(contactNumber);
      } else {
        // Handle API errors
        Swal.fire({
          icon: 'error',
          title: 'Failed to Send OTP',
          text: response.data.message || 'Something went wrong. Please try again.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to send OTP. Please try again.',
      });
    }
  };
  function formatDate(date) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return formattedDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$02-$01-$03');
  }
  const calculateDaysDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const timeDifference = end - start;
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    return Math.abs(Math.floor(daysDifference));
  };



  const handleTrialTimeChange = (time, batchId, status) => {
    if (status === 'Available') {
      setSelectedTrialTime(time);
      setSelectedBatchId(batchId);

      setErrorMessages((prevErrors) => ({ ...prevErrors, selectedTrialTime: '' }));
    }
  };

  const filteredCenters = selectedArea ? areas.find(area => area.name === selectedArea)?.centers || [] : [];

  const sortedCenters = filteredCenters.map(center => {
    const centerData = centers.find(c => c.id === center.id);
    return centerData ? { ...centerData, km: center.km } : null;
  }).filter(center => center !== null).sort((a, b) => a.km - b.km);


  const isContactNumberValid = /^[0-9]{10}$/.test(contactNumber);

  const ConfirmationModal = ({ showModal, onClose, onConfirm, bookingData, selectedBatchId }) => {
    if (!showModal) return null;

    const handleConfirm = async () => {
      try {
        let parentIdToSend = null;
        let childIdToSend = null;

        if (newChildName) {
          // If a new child is being added, set parent ID to the parent's ID and child ID to null
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = null;
        }else if (selectedChildId === 'parent') {
          // If parent is selected, set parent ID to the parent's ID and child ID to the parent's ID
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend =userDetails?.parent?.id || null;; // Use the parent's ID
        } else if (selectedChildId) {
          // If a specific child is selected, set parent ID to the parent's ID and child ID to the selected child's ID
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = selectedChildId;
        } else if (userDetails && !selectedChildId) {
          // If no child is selected and userDetails is present, assume the parent is selecting itself
          parentIdToSend = userDetails?.parent?.id || null;
          childIdToSend = userDetails?.parent?.id || null; // Set child ID to parent ID
        } else {
          // Default case, set both IDs to null
          parentIdToSend = null;
          childIdToSend = null;
        }
    

    
        // Find the selected center's academy_id
        const selectedCenterData = centers.find(
          (center) => center.name === bookingData.selectedCenter
        );
        const academyIdToSend = selectedCenterData ? selectedCenterData.id : null;
    
        // Format mobile number
        const formattedMobileNumber = bookingData.contactNumber.startsWith('+91')
          ? bookingData.contactNumber
          : '+91' + bookingData.contactNumber;
          const formattedProficiencyLevel = proficiencyLevel.toUpperCase();
        // Prepare the booking data
        const bookingDataForPurchase = {
            isPlayingTrial : 0, 
            isCoachingTrial : 1,
            parent_id: parentIdToSend,
            user_id: childIdToSend,
            court_id: null,
            sport_id : 1,
            batch_id: selectedBatchId,
            academy_id_new: academyIdToSend,
            academy_id_prev: previousCenter,
            start_time: bookingData.selectedTrialTime.split(" - ")[0], // Extract start time
            end_time: bookingData.selectedTrialTime.split(" - ")[1], // Extract end time
            booking_date: formatDateToYYYYMMDD(bookingData.selectedTrialDate),
            court_timing_id: null,
            area:selectedArea,
        };



        // Make the API call
        const createOrder = await axios.post(
          process.env.REACT_APP_API_URL_RESCHEDULE,
          bookingDataForPurchase,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-key':process.env.REACT_APP_API_KEY,
            }
          }
        );

        const { bookCourt, trialLog } = createOrder.data;

  if (bookCourt.success && trialLog.success) {
    Swal.fire({
      icon: 'success',
      title: 'Trial Rescheduled!',
      text: 'Your trial has been successfully Rescheduled.',
    });
    onClose();
    setContactNumber('');
    setIsOtpVerified(false);
    setOtp('');
    setShowOtpInput(false);
  } else {
    throw new Error(
      createOrder.data.message || 'Failed to process the booking'
    );
  }
}  catch (error) {
  console.error('Error during confirmation:', error);

  let errorMessage = 'Failed to process the booking';

  // Check if error response exists and extract the message
  if (error.response && error.response.data) {
    errorMessage = error.response.data.message || JSON.stringify(error.response.data);
  } else if (error.message) {
    errorMessage = error.message;
  }


  Swal.fire({
    icon: 'error',
    title: 'Error',
    text: errorMessage,
  });
}
    };
    const formatDateToYYYYMMDD = (dateString) => {
      const [day, month, year] = dateString.split('-');

      const date = new Date(`${year}-${month}-${day}`);
      if (isNaN(date.getTime())) {
        console.error("Invalid date string:", dateString);
        return "Invalid Date";
      }

      const formattedYear = date.getFullYear();
      const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
      const formattedDay = String(date.getDate()).padStart(2, '0');

      return `${formattedYear}-${formattedMonth}-${formattedDay}`;
    };

    return (
      <div className="confirmation-modal-overlay">
        <div className="modal-content">
          <button className="close-btn" onClick={onClose}>
            <span className="close-icon">&times;</span>
          </button>

          <h3 className="modal-title">Your Rescheduling Details</h3>
          <div className="booking-summary">
            <p><strong>Name:</strong> {bookingData.userName}</p>
            <p><strong>Contact Number:</strong> {bookingData.contactNumber}</p>
            <p><strong>Area:</strong> {bookingData.selectedArea}</p>
            <p><strong>Center:</strong> {bookingData.selectedCenter}</p>
            <p><strong>Trial Date:</strong> {bookingData.selectedTrialDate}</p>
            <p><strong>Time Slot:</strong> {bookingData.selectedTrialTime}</p>
          </div>

          <div className="modal-actions">
            <button onClick={handleConfirm} className="btn-confirm">Submit</button>
          </div>
        </div>
      </div>
    );
  };

  const showBackendError = (error) => {
    let errorMessage = 'Something went wrong. Please try again.';

    // Extract error message from backend response
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: errorMessage,
    });
  };

  const handleDateChange = (date) => {
    setHolidayName(null);
    setSelectedTrialDate(date);
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      selectedTrialDate: '',
    }));
  };
  useEffect(() => {
    if (selectedTrialDate && selectedCenter) {
      fetchAvailableSlots();
    }
  }, [selectedTrialDate, selectedCenter]);

  const handleHolidayResponse = (data) => {
    if (data?.is_holiday !== true) return false;

    setAvailableSlots([]);
    setSelectedTrialTime('');
    setSelectedBatchId(null);
    setHolidayName(data.holiday_description || 'Holiday');
    return true;
  };

  const fetchAvailableSlots = async () => {
    setHolidayName(null);
    try {
      const selectedCenterData = centers.find(center => center.name === selectedCenter);
      if (!selectedCenterData) {
        throw new Error('Selected center not found.');
      }

      const formattedDate = formatDateToYYYYMMDD(selectedTrialDate);

      const payload = {
        isPlaying: 0,
        isCoaching: 1,
        academy_id: selectedCenterData.id,
        sport_id: 1,
        batch_type: userCategory === 'Adult' ? "ADULTS" : "KIDS", // Use the selected category
        proficiency_type: proficiencyLevel.toUpperCase(), // Use the selected proficiency level
        booking_date: formattedDate,
      };


      const response = await axios.post(
        process.env.REACT_APP_API_URL_SLOT_CHECK,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': process.env.REACT_APP_API_KEY,
          }
        }
      );
      

      if (handleHolidayResponse(response.data)) return null;

      if (response.data.message === 'Available Playing slots fetched successfully !') {

        setAvailableSlots(response.data.availableCoachingSlots);
      } else {
        throw new Error(response.data.message || 'Failed to fetch available slots.');
      }
    } catch (error) {
      if (handleHolidayResponse(error?.response?.data)) return null;

      console.error('Error fetching available slots:', error);
      showBackendError(error);
    }
  };

  const formatDateToYYYYMMDD = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}:${month}:${day}`;
  };
  useEffect(() => {
    setSelectedTrialTime(null); // ✅ Reset timeslot when date updates
  }, [selectedTrialDate]);
  const [searchQuery, setSearchQuery] = useState('');
  return (
    <div className="enroll-trial-container">
      <h2 className="rescedule-title">
        Reschedule Trial
      </h2>
      <form className="booking-form" onSubmit={handleSubmit}>
        <div className="floating-select">
          <input
            className={`sales-filter-academy ${contactNumber ? 'has-value' : ''}`}
            type="tel"
            value={contactNumber}
            onChange={(e) => handleInputChange(e, 'contactNumber')}
            onKeyPress={(e) => {
              if (!/^[0-9]$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            maxLength={10}
            placeholder="Enter 10-digit phone number"
          />

          {contactNumber && <label htmlFor="contactNumber">Contact Number</label>}
          {errorMessages.contactNumber && <p className="error">{errorMessages.contactNumber}</p>}
          {errorMessages.otp && <p className="error">{errorMessages.otp}</p>}
          {isOtpVerified && (
            <span className="checkmark">✓</span>
          )}

          {!showOtpInput && !isOtpVerified && isContactNumberValid && (
            <button type="button" onClick={handleSendOtpClick} className="btn-send-otp">
              Send OTP
            </button>
          )}
        </div>

        {showOtpInput && !isOtpVerified && (
          <div className="floating-select">
            <input
              className={`sales-filter-academy ${otp ? 'has-value' : ''}`}
              type="text"
              value={otp}
              onChange={(e) => handleInputChange(e, 'otp')}
              maxLength={6}
              placeholder="Enter OTP"
            />
            <button type="button" onClick={handleOtpVerification} className="btn-send-otp">
              Verify OTP
            </button>
          </div>
        )}


{isOtpVerified && userDetails && (
  <div className="floating-select-child" ref={selectWrapperRef}>
    <label htmlFor="child" className="selectchild">Select User</label>

    <div className={`sales-filter-academy ${userName ? 'has-value' : ''}`}>
      <div className="custom-options">
        {/* Add Parent as an option only if they are eligible */}
        {userDetails.parent?.trial_details &&
          userDetails.parent.trial_details.sport_id === 1 &&
          userDetails.parent.trial_details.trial_type === 'COACHING' ? (
          <div
            className={`custom-option ${selectedChildId === 'parent' ? 'selected' : ''}`}
            onClick={() => handleChildSelect({ isParent: true, name: userDetails.parent.name })}
          >
            <input
              type="radio"
              checked={selectedChildId === 'parent'}
              readOnly
              className="radio-dot"
            />
            <span>{userDetails.parent.name}</span>
          </div>
        ) : null}

        {/* Render Filtered Children */}
        {filteredChildren.length > 0 &&
          filteredChildren.map((child, index) => (
            <div
              key={index}
              className={`custom-option ${selectedChildId === child.id ? 'selected' : ''}`}
              onClick={() => handleChildSelect(child)}
            >
              <input
                type="radio"
                checked={selectedChildId === child.id}
                readOnly
                className="radio-dot"
              />
              <span>{child.name}</span>
            </div>
          ))}
      </div>
    </div>

    {errorMessages.child && <p className="error">{errorMessages.child}</p>}
  </div>
)}



        { selectedChildId && isOtpVerified && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Category:</label>
            <div className="trial-time-options">
              <button
                type="button"
                className={`trial-time-option ${userCategory === 'Adult' ? 'selected' : ''}`}
                onClick={() => handleCategoryChange('Adult')}
              >
                Adult
              </button>
              <button
                type="button"
                className={`trial-time-option ${userCategory === 'Kids' ? 'selected' : ''}`}
                onClick={() => handleCategoryChange('Kids')}
              >
                Kids
              </button>
            </div>
            {errorMessages.userCategory && <p className="error">{errorMessages.userCategory}</p>}
          </div>
        )}

        {selectedChildId && isOtpVerified  && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Proficiency Level:</label>
            <div className="trial-time-options">
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Basic' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Basic')}
              >
                Beginner
              </button>
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Intermediate' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Intermediate')}
              >
                Intermediate
              </button>
              <button
                type="button"
                className={`trial-time-option ${proficiencyLevel === 'Advanced' ? 'selected' : ''}`}
                onClick={() => handleProficiencyChange('Advanced')}
              >
                Advance
              </button>
            </div>
            {errorMessages.proficiencyLevel && <p className="error">{errorMessages.proficiencyLevel}</p>}
          </div>
        )}
        
        {selectedChildId && isOtpVerified && (
          <div className="floating-select" ref={selectWrapperRef}>
            <div
              className={`sales-filter-academy ${selectedArea ? 'has-value' : ''}`}
              onClick={() => setShowAreaDropdown(true)} // Only open, don't toggle
            >
              <div className="selected-option">
                {selectedArea || 'Select an Area'}
              </div>
              <div
                className={`custom-dropdown ${showAreaDropdown ? 'open' : ''}`}
                ref={areaDropdownRef}
                onClick={(e) => e.stopPropagation()} // Prevent closing when interacting with search
              >
                {showAreaDropdown && (
                  <input
                    type="text"
                    placeholder="Search area..."
                    className="search-input"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onClick={(e) => e.stopPropagation()} // Ensure input box doesn’t close dropdown
                  />
                )}
                {areas
                  .filter((area) => area.name.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map((area, index) => (
                    <div
                      key={index}
                      className="custom-option"
                      onClick={() => {
                        handleAreaChange(area.name);
                        setShowAreaDropdown(false); // Close dropdown after selection
                      }}
                    >
                      {area.name}
                    </div>
                  ))}
              </div>
            </div>
            {selectedArea && <label htmlFor="selectedArea">Area</label>}
            {errorMessages.selectedArea && <p className="error">{errorMessages.selectedArea}</p>}
          </div>
        )}

        {selectedChildId && isOtpVerified && selectedArea && (
          <div className="floating-select" ref={selectWrapperRef}>
            <div
              className={`sales-filter-academy ${selectedCenter ? 'has-value' : ''}`}
              onClick={() => setShowCenterDropdown(!showCenterDropdown)}
            >
              <div className="selected-option">
                {selectedCenter || 'Select Center'}
              </div>
              <div
                className={`custom-dropdown ${showCenterDropdown ? 'open' : ''}`}
                ref={centerDropdownRef}
              >
                {sortedCenters.map((center) => (
                  <div
                    key={center.id}
                    className="custom-option"
                    onClick={() => handleCenterChange(center.name)}
                  >
                    {center.name} ({center.km} km)
                  </div>
                ))}
              </div>
            </div>
            {selectedCenter && <label htmlFor="selectedCenter">Center</label>}
            {errorMessages.selectedCenter && <p className="error">{errorMessages.selectedCenter}</p>}
          </div>
        )}
         {selectedChildId && isOtpVerified && selectedCenter && (
           <div><label className="form-date">Trial Date:</label></div>
         )}
        {selectedChildId && isOtpVerified && selectedCenter && (
         
          <div className="floating-select">
   
            
            <DatePicker
              className={`sales-filter-academy ${selectedTrialDate ? 'has-value' : ''}`}
              selected={selectedTrialDate}
              onChange={handleDateChange}
              minDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select trial date"
              required
              inline
            />
            {holidayName && <HolidayNotice name={holidayName} />}
            {errorMessages.selectedTrialDate && (
              <p className="error">{errorMessages.selectedTrialDate}</p>
            )}
          </div>
        )}



        {selectedChildId && isOtpVerified && selectedTrialDate && !holidayName && (
          <div className="trial-time-picker">
            <label className="trial-time-label">Time Slot:</label>
            <div className="trial-time-options">
              {availableSlots.length > 0 ? (
                availableSlots.map((slot, index) => {
                  const startTime = slot.start_time ? slot.start_time.slice(0, 5) : 'N/A';
                  const endTime = slot.end_time ? slot.end_time.slice(0, 5) : 'N/A';
                  const isAvailable = slot.status === 'Available';

                  return (
                    <button
                      key={index}
                      className={`trial-time-option ${selectedTrialTime === `${startTime} - ${endTime}` ? 'selected' : ''
                        } ${!isAvailable ? 'disabled' : ''}`}
                      onClick={() =>
                        handleTrialTimeChange(`${startTime} - ${endTime}`, slot.batch_id, slot.status)
                      }
                      disabled={!isAvailable}
                    >
                      <div>
                        {startTime} - {endTime}
                      </div>
                      <div>{slot.status}</div>
                    </button>
                  );
                })
              ) : (
                <p className="no-time-slot">No Time Slots Available</p>
              )}
            </div>

            {errorMessages.selectedTrialTime && (
              <p className="error">{errorMessages.selectedTrialTime}</p>
            )}
          </div>
        )}


        <div className="form-group">
          <button className="form-button" type="submit">Submit</button>

        </div>

        <ConfirmationModal
          showModal={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          selectedBatchId={selectedBatchId}
          onConfirm={() => {
            alert('Booking Confirmed!');
            setShowConfirmationModal(false);

          }}
          bookingData={formData}
        />
      </form>
    </div>
  );
};

export default Reschedule
